import { t } from '../../../../services/i18nService';
import idVerificationService from '../../../../services/idverification/IdVerificationService';
import manualIdVerificationService from '../../../../services/manualidverification/ManualIdVerificationService';
import sessionReader from '../../../../store/readHelpers/SessionReader';

const testComponentPreChecksSelector = {
    computeProps(ownProps) {
        const { readinessCheckComponent, isReadinessCheckComplete } = ownProps;

        return {
            hardwareArePreviousChecksComplete: readinessCheckComponent ? !!isReadinessCheckComplete : true,
            showAudioVideoCheck: sessionReader.isVideoAudioCheckEnabled(),
            showAutomaticIdVerification: idVerificationService.needsIdVerification(),
            showManualIdVerification: manualIdVerificationService.isManualIdVerificationNeeded(),
            showRoomScan: sessionReader.isRemoteProctoringRoomscanEnabled(),
            title: t('testOverview.preChecksTitle'),
        };
    },
};

export default testComponentPreChecksSelector;
